export default __webpack_public_path__ + "static/media/izettle1.af1d686a.png";